/**
 *  偏好設定相關
 */

import cookies from 'js-cookie'
const cookieName = 'mcipPreference'

// 偏好設定的預設值
const defaultPreference = {
  isDarkTheme: cookies.get('mcipIsDarkTheme') === 'true', // 是否使用深色主題
  isUsingNotoSans: true, // 是否使用思源黑體
  isDebugMode: false, // 是否開啟偵錯模式
}

/**
 * 取得偏好設定物件
 * @return {Object} 偏好設定物件
 */
const get = () => {
  let data = null
  try {
    data = JSON.parse(cookies.get(cookieName))
  } catch (e) { }

  if (data) {
    Object.keys(defaultPreference).forEach(key => {
      if (!(key in data)) data[key] = defaultPreference[key]
    })
    return data
  } else {
    return defaultPreference
  }
}

/**
 * 設定偏好設定
 * @params {Object} 新的偏好設定物件
 */
const set = (_) => {
  const newData = JSON.stringify({ ...get(), ..._ })
  cookies.set(cookieName, newData, { expires: 365 })
}

export default {
  get,
  set,
}
